export default "/images/framework/BgBlack.ffa7263b.svg?ffa7263b";